module.exports = __webpack_public_path__ + "img/records-canceled-en.273c4335.png";